import {createSlice} from '@reduxjs/toolkit';

export const CREATE_USER_MODAL = 'createUserModal'
export const CREATE_EVENT_MODAL = 'createEventModal'
export const SCHEDULE_SETTINGS_MODAL = 'scheduleSettingsModal'
export const CREATE_EVENT_TYPE_MODAL = 'createEventTypeModal'
export const EVENT_MANAGEMENT_MODAL = 'eventManagementModal'
export const BOOKING_SERVICES_DISPLAY_MODAL = 'bookingServicesDisplayModal'
export const SETTINGS_VALUE_MODAL = 'settingsValueModal'
export const MANAGE_CATEGORIES_MODAL = 'manageCategoriesModal'
export const CREATE_GROUP_CATEGORY_MODAL = 'createGroupCategoryModal'
export const REGISTER_CHECK_IN_ACCESS_CONTROL_MODAL = 'registerCheckInAccessControlModal'
export const ACCESS_CONTROL_SETTINGS_MODAL = 'accessControlSettingsModal'
export const ACCESS_CONTROL_ENTRANCE_HISTORY_MODAL = 'accessControlEntranceHistoryModal'
export const MULTIPLE_HOLDS_MODAL = 'multipleHoldsModal'
export const MULTIPLE_HOLDS_UPDATE_MODAL = 'multipleHoldsUpdateModal'
export const ADD_SHIFT_MODAL = 'addShiftModal'
export const MULTIPLE_UPDATE_MODAL = 'multipleUpdateModal'
export const MULTIPLE_SUBSCRIPTION_UPDATE_MODAL = 'multipleSubscriptionUpdateModal'
export const MARK_AS_LOST_MODAL = 'markAsLostModal'
export const SMS_PURCHASE_MODAL = 'smsPurchaseModal'
export const UPDATE_STATUS_MODAL = 'updateStatusModal'
export const GATE_SELECTION_MODAL = 'gateSelectionModal'
export const ACCESS_CONTROL_GROUP_MODAL = 'accessControlGroupModal'
export const GATE_SELECTION_TCP_MODAL = 'gateSelectionTCPModal'
export const MESSAGE_DESCRIPTION_MODAL = 'messageDescriptionModal'
export const CONNECT_TO_INVOICES_MODAL = 'connectToInvoicesModal'
export const CONNECT_TO_MESHULAM_MODAL = 'connectToMeshulamModal'
export const MEMBERSHIP_TYPE_PROPS_MODAL = 'membershipTypePropsModal'
export const TASKS_SETTINGS_MODAL = 'tasksSettingsModal'

export const EDIT_ALL_TASKS_MODAL = 'editAllTasksModal'
export const MULTIPLE_RECURRING_PRICE_UPDATE_MODAL = 'multipleRecurringPriceUpdateModal'
export const STEPPER_CONFIRM_MODAL = 'stepperConfirmModal'
export const LIMITED_PACKAGE_MODAL = 'limitedPackageModal'
export const UPDATE_LEAD_OWNER_MODAL = 'updateLeadOwnerModal'
export const UPDATE_LEAD_SOURCE_MODAL = 'updateLeadSourceModal'
export const UPDATE_LOST_REASON_MODAL = 'updateLostReasonModal'
export const FLOW_MANAGER_MODAL = 'flowManagerModal'
export const WHATSAPP_INTEGRATION_MODAL = 'whatsAppIntegrationModal'
export const UPDATE_PAYMENT_METHOD_MODAL = 'updatePaymentMethodModal'
export const USER_AI_SUMMARY_MODAL = 'userAiSummaryModal'
export const VIEW_USER_NOTE_MODAL = 'viewUserNoteModal'
export const LINK_DISPLAY_MODAL = 'linkDisplayModal'
export const HUGIM_GROUPS_REPORT_MODAL = 'hugimGroupsReportModal'
export const RESTORE_USER_MODAL = 'restoreUserModal'
export const CONNECT_TO_INBOX_AI_MODAL = 'connectToInboxAIModal'
export const SET_START_NUMBER_MODAL = 'setStartNumberModal'
export const DOCUMENT_SUCCESS_MODAL = 'documentSuccessModal'
export const GENERAL_NOTE_VIEW_MODAL = 'generalNoteViewModal'
export const VIDEO_TUTORIAL_MODAL = 'videoTutorialModal'
export const META_WHATSAPP_EMBEDDED_SIGNUP_MODAL = 'metaWhatsappEmbeddedSignupModal'

const initValues = {
    isOpen: false,
    props: null,
    processRes: null,
    hide: false,
    onClose: null
}

const modalManagerSlice = createSlice({
    name: "modalManager",
    initialState: {
        createEventModal: {...initValues},
        createUserModal: {...initValues},
        scheduleSettingsModal: {...initValues},
        createEventTypeModal: {...initValues},
        eventManagementModal: {...initValues},
        bookingServicesDisplayModal: {...initValues},
        settingsValueModal: {...initValues},
        manageCategoriesModal: {...initValues},
        createGroupCategoryModal: {...initValues},
        registerCheckInAccessControlModal: {...initValues},
        accessControlSettingsModal: {...initValues},
        multipleHoldsModal: {...initValues},
        multipleHoldsUpdateModal: {...initValues},
        addShiftModal: {...initValues},
        multipleUpdateModal: {...initValues},
        multipleSubscriptionUpdateModal: {...initValues},
        markAsLostModal: {...initValues},
        updateStatusModal: {...initValues},
        smsPurchaseModal: {...initValues},
        messageDescriptionModal: {...initValues},
        gateSelectionModal: {...initValues},
        gateSelectionTCPModal: {...initValues},
        connectToInvoicesModal: {...initValues},
        tasksSettingsModal: {...initValues},
        multipleRecurringPriceUpdateModal: {...initValues},
        stepperConfirmModal: {...initValues},
        limitedPackageModal: {...initValues},
        editAllTasksModal: {...initValues},
        accessControlEntranceHistoryModal: {...initValues},
        accessControlGroupModal: {...initValues},
        connectToMeshulamModal: {...initValues},
        updateLeadOwnerModal: {...initValues},
        updateLeadSourceModal: {...initValues},
        updateLostReasonModal: {...initValues},
        flowManagerModal: {...initValues},
        whatsAppIntegrationModal: {...initValues},
        updatePaymentMethodModal: {...initValues},
        membershipTypePropsModal: {...initValues},
        userAiSummaryModal: {...initValues},
        viewUserNoteModal: {...initValues},
        linkDisplayModal: {...initValues},
        hugimGroupsReportModal: {...initValues},
        restoreUserModal: {...initValues},
        connectToInboxAIModal: {...initValues},
        setStartNumberModal: {...initValues},
        documentSuccessModal: {...initValues},
        generalNoteViewModal: {...initValues},
        videoTutorialModal: {...initValues},
        metaWhatsappEmbeddedSignupModal: {...initValues},
    },
    reducers: {
        openModal: (state, data) => {
            const modalName = data.payload.modalName
            if (modalName) {
                state[modalName].isOpen = true
                state[modalName].props = data.payload.props
                state[modalName].processRes = null
                state[modalName].onClose = data.payload.onClose ?? null
            }
        },
        closeModal: (state, data) => {
            const modalName = data.payload.modalName
            if (modalName) {
                state[modalName].isOpen = false
                state[modalName].hide = false
                state[modalName].props = null
            }
        },
        updateModalRes: (state, data) => {
            const modalName = data.payload.modalName
            if (modalName) {
                state[modalName].processRes = data.payload.res
            }
        },
        hideModal: (state, data) => {
            const modalName = data.payload.modalName
            if (modalName) {
                state[modalName].hide = data.payload.hide
            }
        },
        setLoadingModal: (state, data) => {
            const modalName = data.payload.modalName
            if (modalName) {
                state[modalName].props.isConfirmLoading = data.payload.isConfirmLoading
            }
        },
        updateModalProps: (state, data) => {
            const modalName = data.payload.modalName
            if (modalName && state[modalName].isOpen) {
                state[modalName].props = { ...state[modalName].props, ...data.payload.props }
            }
        }
    },
});

export const {openModal, closeModal, updateModalRes, hideModal, setLoadingModal, updateModalProps} = modalManagerSlice.actions;

export default modalManagerSlice.reducer;